export default __webpack_public_path__ + "static/media/vegetationimg.a8ddf2cf.svg";